<template>
  <div class="card">
    <div class="card-header pb-0">
      <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Guest Categories</span>
      <span class="text-secondary text-xs">Press view on the category below that you want to edit.</span>
      <span style="float: right">
        <argon-button @click="openEditor('createCategory')" color="success" size="md">Add Category</argon-button>
      </span>
    </div>

    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-8">Category Name</th>
              <th class="text-secondary text-uppercase text-xxs font-weight-bolder opacity-7 col-2">Total Guests</th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(category, index) in guestCategories">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <img src="https://www.svgrepo.com/show/55152/account.svg" class="avatar avatar-sm me-3 avatar-admin" alt="user1" />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ category.name }}</h6>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="badge badge-sm bg-gradient-secondary">None</span>
              </td>
              <td class="align-middle">
                <a href="javascript:;" @click="this.openEditor('viewCategory', category.id, category.name)" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">View</a>
                <a href="javascript:;" @click="deleteCategory(category.id, category.name)" class="text-danger font-weight-bold text-xs mx-5" data-toggle="tooltip" data-original-title="Edit user">Delete</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";

  import ArgonButton from "@/components/ArgonButton.vue";

  export default {
    name: "template-table",
    components: {
      ArgonButton,
    },
    data() {
      return {
        categories: {},
      };
    },
    computed: {
      guestCategories() {
        return this.categories;
      },
    },
    methods: {
      getAllCategory() {
        let JWTToken = localStorage.getItem("token");

        axios
          .get("https://api.macra.co.id/mavent/guest-category/all", { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then((res) => {
            this.categories = res.data;
            console.log(this.categories);
          })
          .catch((err) => {
            alert(err.message);
          });
      },
      formatDate(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [day, month, year].join("/");
      },
      openEditor(mode, row = null, catName = null) {
        var editorData = { isOpen: true, mode: mode, requestedrow: row, name: catName };
        this.$store.state.freeEditor = editorData;
        console.log(this.$store.state.freeEditor);
      },
      deleteCategory(id, full_name) {
        let JWTToken = localStorage.getItem("token");
        if (confirm("Delete Category : " + full_name + "?")) {
          axios
            .delete("https://api.macra.co.id/mavent/guest-category/delete/" + id, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert("Account Deleted");
              location.reload();
            })
            .catch((error) => {
              alert(error.mesage);
            });
        } else {
          // Do nothing!
        }
      },
    },
    created() {
      let JWTToken = localStorage.getItem("token");

      this.getAllCategory();
    },
  };
</script>

<style scoped>
  .avatar-admin {
    filter: invert(72%) sepia(20%) saturate(921%) hue-rotate(133deg) brightness(92%) contrast(93%);
  }
</style>
